import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter, useLocation } from "react-router-dom";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import { getUserProfile } from "store/actions";
import FilterBar from "components/Common/FilteringBar";
import TableComponent from "../../components/Common/TableComponent";
import ModalHCATypes from "components/Modals/ModalHCATypes";
import ButtonAdd from "components/Common/ButtonAdd.js";
import * as endpoints from "constants/endpoints";
import { GetData } from "../../helpers/CRUD.js";
import i18next from "i18next";
import IconCheck from "components/Common/IconCheck";
import IconX from "components/Common/IconX";
import Pagination from "components/Common/Pagination";
import PaginationSelect from "components/Common/PaginationSelect";

const HCATypes = (props) => {
  const [state, setState] = useState({
    pageTitle: i18next.t("link-hca-types-tooltip"),
    hca_types: [],
    isLoading: false,
    isLoaded: false,
    page: 1,
    totalCount: null,
    pageSize: 100,
    sorterLabel: "",
    sorterDirection: "",
    isModalOpen: false,
    isActive: true,
  });

  const location = useLocation();

  const emitErrors = (error) => {
    props.onErrorsShow(error.body);
  };

  const emitSuccess = (success) => {
    props.onSuccessShow(success);
  };

  const openModal = () => {
    setState((state) => ({ ...state, isModalOpen: !state.isModalOpen }));
    removeBodyCss();
  };

  const closeModal = () => {
    setState((state) => ({ ...state, isModalOpen: false }));
    removeBodyCss();
  };

  const closeAndUpdate = (modalCallback) => {
    setState((state) => ({ ...state, isModalOpen: false }));
    modalCallback();
    removeBodyCss();
  };

  const removeBodyCss = () => {
    document.body.classList.add("no_padding");
  };

  const getAllHCATypes = () => {
    setState((state) => ({
      ...state,
      isLoaded: false,
      hca_types: [],
    }));

    let endpointSortAdd = "";

    if (state.sorterLabel !== "") {
      endpointSortAdd = `&orderBy=${state.sorterLabel}_${state.sorterDirection}`;
    }
    const url = `${endpoints.NOMENCLATURE_ENDPOINT}/HeatCostAllocatorType/GetAll?filterText=&page=${state.page}&size=${state.pageSize}${endpointSortAdd}&isActive=${state.isActive}`;

    GetData(
      url,
      (data) => {
        let tableBodyData;

        if (data) {
          tableBodyData = data.items.map((item) => {
            return {
              id: item.id,
              data: {
                name: item.name,
                radio_module: item.hasRadioModule ? <IconCheck /> : <IconX />,
                isActive: item.isActive,
              },
            };
          });
        }

        setState((state) => ({
          ...state,
          hca_types: tableBodyData,
          isLoaded: true,
          totalCount: data.totalCount,
        }));
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const updatePage = (page) => {
    setState((state) => ({ ...state, page }));
  };

  const onPageSizeUpdate = (pageSize) => {
    setState((state) => ({ ...state, pageSize, page: 1 }));
  };

  const onSorterClick = (label, direction) => {
    setState((state) => ({
      ...state,
      page: 1,
      sorterLabel: label,
      sorterDirection: direction,
    }));
  };

  useEffect(() => {
    getAllHCATypes();
  }, [state.page, state.pageSize, state.isActive]);

  useEffect(() => {
    onPageSizeUpdate(state.pageSize);
  }, [state.isActive]);

  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    setState((state) => ({
      ...state,
      loggedUserType: obj.role,
      isLoading: true,
    }));

    if (location.state) {
      setState((state) => ({ ...state, mode: "edit" }));
    }
  }, []);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <CardTitle className="mb-4">{state.pageTitle}</CardTitle>
                </Col>

                <Col md="2" className="ml-auto mr-0">
                  <PaginationSelect
                    pageSize={state.pageSize}
                    index={1}
                    onPageSizeUpdate={onPageSizeUpdate}
                  />
                </Col>

                <Col className="text-right col-md-1">
                  <ButtonAdd
                    onBtnClick={openModal}
                    data-toggle="modal"
                    tooltip="Добави нов HCA"
                  />
                </Col>
              </Row>

              <FilterBar
                tableData={state.hca_types}
                isActive
                state={state}
                setState={setState}
              ></FilterBar>

              <TableComponent
                dataHead={[
                  i18next.t("name"),
                  i18next.t("radio"),
                  i18next.t("actions"),
                ]}
                dataBody={state.hca_types}
                sorterData={["name", "hasRadioModule"]}
                onSorterClick={onSorterClick}
                url_path={"hca-types"}
                category={"hca-types"}
                enableLinkView={true}
                isLoading={state.isLoading}
                isLoaded={state.isLoaded}
              />

              <Pagination
                updatePage={updatePage}
                page={state.page}
                totalCount={state.totalCount}
                pageSize={state.pageSize}
              />

              <ModalHCATypes
                isModalOpen={state.isModalOpen}
                closeModal={closeModal}
                update={() => closeAndUpdate(getAllHCATypes)}
                emitErrors={emitErrors}
                emitSuccess={emitSuccess}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

HCATypes.propTypes = {
  userProfile: PropTypes.any,
  onGetUserProfile: PropTypes.func,
};

const mapStateToProps = ({ contacts }) => ({
  userProfile: contacts.userProfile,
});

const mapDispatchToProps = (dispatch) => ({
  onGetUserProfile: () => dispatch(getUserProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HCATypes));
